import type * as React from 'react';

import dawnLogoFull from '../../assets/images/dawn-logo-full.svg';
import logoSymbol from '../../assets/images/logo-symbol-sidebar.svg';
import logotype from '../../assets/images/logotype.svg';
import { cn } from '../../lib/utils';

export interface LogoProps {
  /** When true, shows only the symbol (used for collapsed sidebar). Ignored for `size='lg'`. */
  collapsed?: boolean;
  /**
   * Visual size. `sm` (default) = sidebar/auth size (symbol 32×32 + 79×20
   * logotype), unchanged for existing callers. `lg` = the full-color mark at
   * 195×54 used on the onboarding Welcome screen (Figma `5:2626`).
   */
  size?: 'sm' | 'lg';
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({ collapsed = false, size = 'sm', className }) => {
  if (size === 'lg') {
    return (
      <img src={dawnLogoFull} alt="Dawn" className={cn('w-[195px] h-[54px] shrink-0', className)} />
    );
  }

  return (
    <div className={cn('flex items-center gap-[7px] shrink-0', className)}>
      <img src={logoSymbol} alt="Dawn" className="w-[32px] h-[32px]" />
      {!collapsed && <img src={logotype} alt="Dawn" className="w-[79px] h-[20px]" />}
    </div>
  );
};

Logo.displayName = 'Logo';
